module.exports = __webpack_public_path__ + "media/message 10.56b36d38.mp3";